module.exports = __webpack_public_path__ + "static/media/woocommerce-addplugin.16022c4c.png";